import React, { useState, useCallback } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import ChatWithUs from "../../components/ChatWithUs/ChatWithUs";
import { useInquiry } from "../../context/InquiryContext";
import FoodHeroImage from "../../assets/Food-display-2.png";

// Icons
import Icon300Skus from "../../assets/icons/icon_300_skus_box.png";
import IconMixedContainer from "../../assets/icons/icon_mixed_container.png";
import IconSourcingPin from "../../assets/icons/icon_sourcing_pin.png";
import IconEndToEnd from "../../assets/icons/icon_end_to_end_support.png";
import IconSelectProducts from "../../assets/icons/icon_select_products.png";
import IconMixCategories from "../../assets/icons/icon_mix_categories.png";
import IconPrepareShipment from "../../assets/icons/icon_prepare_shipment.png";
import IconShipWorldwide from "../../assets/icons/icon_ship_worldwide.png";
import IconGlobe from "../../assets/icons/icon_ready_order_globe_ship.png";
import IconArrow from "../../assets/icons/icon_arrow_right.png";

// Products
import CannedTuna from "../../assets/food-and-beverages/Canned-Canned-Tuna.png";
import Sardines from "../../assets/food-and-beverages/Canned-Sardines.png";
import GlutenousRiceFlour from "../../assets/food-and-beverages/Flour-Glutenous-Rice-Flour.png";
import RiceFlour from "../../assets/food-and-beverages/Flour-Rice-Flour.png";
import SushiGingerNatural from "../../assets/food-and-beverages/Ginger-Sushi-Ginger-(Natural Color).png";
import SushiGingerPink from "../../assets/food-and-beverages/Ginger-Sushi-Ginger-(Pink Color).png";
import GreenCurryPaste from "../../assets/food-and-beverages/Pastes-Green-Curry-Paste.jpg";
import RedCurryPaste from "../../assets/food-and-beverages/Pastes-Red-Curry-Paste.jpg";
import RicePaper from "../../assets/food-and-beverages/RiceProducts-Rice-Paper.png";
import RiceVermicelli from "../../assets/food-and-beverages/RiceProducts-Rice-Vermicelli.png";
import SoyaSauce from "../../assets/food-and-beverages/Sauces-Soya-Sauce.png";
import SrirachaChiliSauce from "../../assets/food-and-beverages/Sauces-Sriracha-Chili-Sauce.png";
import KnorrChickenSeasoning from "../../assets/food-and-beverages/Seasoning-KNORR-CHICKEN-SEASONING.png";
import KnorrAromatSeasoning from "../../assets/food-and-beverages/Seasonings-KNORR-AROMAT-SEASONING.png";
import CurryPowder from "../../assets/food-and-beverages/Spices-Curry-Powder.png";
import GroundBlackPepper from "../../assets/food-and-beverages/Spices-Ground-Black-Pepper.png";
import CoarseTapiocaStarch from "../../assets/food-and-beverages/Starch-Coarse-Tapioca-Starch.png";
import PotatoStarch from "../../assets/food-and-beverages/Starch-Potato-Starch.png";
import MilkTeaPowder from "../../assets/food-and-beverages/Teas-3in1-Milk-Tea-Powder.png";
import ThaiTeaMix from "../../assets/food-and-beverages/Teas-Thai-Tea-Mix.png";

import "./FoodAndBeverages.css";

const usp = [
  { icon: Icon300Skus,        title: "300+ SKUs",                sub: "Wide range of food & beverage products" },
  { icon: IconMixedContainer, title: "Mixed Container Orders",   sub: "FCL, LCL, air/courier – you choose" },
  { icon: IconSourcingPin,    title: "Thailand & China Sourcing",sub: "Quality products from trusted suppliers" },
  { icon: IconEndToEnd,       title: "End-to-End Support",       sub: "Documentation, packing & delivery support" },
];

const steps = [
  { icon: IconSelectProducts,  num: 1, title: "Select Products",   desc: "Browse our catalogue and choose the products you need." },
  { icon: IconMixCategories,   num: 2, title: "Mix Categories",    desc: "Combine products across brands and suppliers." },
  { icon: IconPrepareShipment, num: 3, title: "Prepare Shipment",  desc: "We handle packing, documentation and export preparation." },
  { icon: IconShipWorldwide,   num: 4, title: "Ship Worldwide",    desc: "FCL, LCL, air or courier – delivered to you." },
];

const products = [
  { name: "3in1 Milk Tea Powder",        category: "Teas",          image: MilkTeaPowder },
  { name: "Thai Tea Mix",                category: "Teas",          image: ThaiTeaMix },
  { name: "Soya Sauce",                  category: "Sauces",        image: SoyaSauce },
  { name: "Sriracha Chili Sauce",        category: "Sauces",        image: SrirachaChiliSauce },
  { name: "Green Curry Paste",           category: "Pastes",        image: GreenCurryPaste },
  { name: "Red Curry Paste",             category: "Pastes",        image: RedCurryPaste },
  { name: "Knorr Chicken Seasoning",     category: "Seasoning",     image: KnorrChickenSeasoning },
  { name: "Knorr Aromat Seasoning",      category: "Seasonings",    image: KnorrAromatSeasoning },
  { name: "Curry Powder",                category: "Spices",        image: CurryPowder },
  { name: "Coarse Tapioca Starch",       category: "Starch",        image: CoarseTapiocaStarch },
  { name: "Rice Vermicelli",             category: "RiceProducts",  image: RiceVermicelli },
  { name: "Canned Tuna",                 category: "Canned",        image: CannedTuna },
  { name: "Sardines",                    category: "Canned",        image: Sardines },
  { name: "Glutenous Rice Flour",        category: "Flour",         image: GlutenousRiceFlour },
  { name: "Rice Flour",                  category: "Flour",         image: RiceFlour },
  { name: "Sushi Ginger (Natural)",      category: "Ginger",        image: SushiGingerNatural },
  { name: "Sushi Ginger (Pink)",         category: "Ginger",        image: SushiGingerPink },
  { name: "Ground Black Pepper",         category: "Spices",        image: GroundBlackPepper },
  { name: "Rice Paper",                  category: "RiceProducts",  image: RicePaper },
  { name: "Potato Starch",               category: "Starch",        image: PotatoStarch },
];

const FoodAndBeverages = () => {
  const { addInquiry } = useInquiry();
  const [toast, setToast] = useState(null); // { name }

  const handleAddToInquiry = useCallback((product) => {
    addInquiry({
      productName: product.name,
      product: product.name,
      country: "Thailand",
      category: product.category,
      image: product.image,
      selectedTags: null,
      fullTags: null,
      requirements: null,
      additionalText: null,
    });
    setToast(product.name);
    setTimeout(() => setToast(null), 2500);
  }, [addInquiry]);

  return (
    <>
      <Navbar />
      {toast && (
        <div className="fab-toast">
          <span>✓</span> <strong>{toast}</strong> added to inquiry
        </div>
      )}
      <div className="fab-page">

        {/* ── Hero ── */}
        <div className="fab-hero" style={{ backgroundImage: `url(${FoodHeroImage})` }}>
          <div className="fab-hero-overlay" />
          <div className="fab-hero-content">
            <h1 className="fab-hero-title">FOOD &amp;<br />BEVERAGES</h1>
            <div className="fab-hero-rule" />
            <p className="fab-hero-sub">
              Sourcing quality products from Thailand and China and consolidating
              them into one shipment – simple, reliable and efficient.
            </p>
          </div>
        </div>

        {/* ── USP bar ── */}
        <div className="fab-usp-bar">
          <div className="fab-usp-inner">
            {usp.map((u) => (
              <div key={u.title} className="fab-usp-item">
                <img src={u.icon} alt={u.title} className="fab-usp-icon" />
                <div>
                  <p className="fab-usp-title">{u.title}</p>
                  <p className="fab-usp-sub">{u.sub}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ── How it works ── */}
        <section className="fab-how-section">
          <h2 className="fab-how-heading">How Newbell Makes Importing Simple</h2>
          <div className="fab-how-rule" />
          <div className="fab-steps">
            {steps.map((s, i) => (
              <React.Fragment key={s.num}>
                <div className="fab-step">
                  <div className="fab-step-icon-wrap">
                    <img src={s.icon} alt={s.title} className="fab-step-icon" />
                    <span className="fab-step-num">{s.num}</span>
                  </div>
                  <p className="fab-step-title">{s.title}</p>
                  <p className="fab-step-desc">{s.desc}</p>
                </div>
                {i < steps.length - 1 && (
                  <img src={IconArrow} alt="" className="fab-step-arrow" />
                )}
              </React.Fragment>
            ))}
          </div>
        </section>

        {/* ── Best Sellers ── */}
        <section className="fab-sellers-section">
          <div className="fab-sellers-header">
            <div>
              <h2 className="fab-sellers-title">Best Sellers</h2>
              <div className="fab-sellers-rule" />
            </div>
            <Link to="/contact" className="fab-view-all-btn">
              View our full catalogue <img src={IconArrow} alt="" className="fab-btn-arrow" />
            </Link>
          </div>

          <div className="fab-product-grid">
            {products.map((p) => (
              <div key={p.name} className="fab-product-card">
                <div className="fab-product-img-wrap">
                  <img src={p.image} alt={p.name} className="fab-product-img" />
                </div>
                <div className="fab-product-info">
                  <p className="fab-product-name">{p.name}</p>
                  <p className="fab-product-cat">{p.category}</p>
                </div>
                <button className="fab-add-btn" onClick={() => handleAddToInquiry(p)}>Add to Inquiry</button>
              </div>
            ))}
          </div>
        </section>

        {/* ── Bottom CTA ── */}
        <section className="fab-cta-section">
          <div className="fab-cta-card">
            <img src={IconGlobe} alt="" className="fab-cta-globe" />
            <div className="fab-cta-text">
              <p className="fab-cta-heading">Ready to build your order?</p>
              <p className="fab-cta-sub">
                Contact our team today and get a tailored quotation based on your product mix and destination.
              </p>
            </div>
            <Link to="/contact" className="fab-cta-btn">
              View Our Full Catalogue <img src={IconArrow} alt="" className="fab-btn-arrow" />
            </Link>
          </div>
        </section>

      </div>
      <Footer />
      <ChatWithUs />
    </>
  );
};

export default FoodAndBeverages;
